export const FORM_ACTIONS = {
  VIEW: 'view',
  ADD: 'add',
  EDIT: 'edit',
};
